export const isNotDefined = (ownership) => {
  return (!ownership || !ownership.name)
}
